import type { LeadTimeEntry } from '../types';
import { getLeadTimeEntries, getLeadTimeEntriesByDeal } from './leadTimeTrackingService';
import { selectLeadTimeForProject } from './projectLeadTime';

/** Lead rows for one project: tagged to its deal, plus untagged time on the originating lead. */
export async function loadLeadTimeForProject(scope: {
  dealId?: string | null;
  leadId?: string | null;
}): Promise<LeadTimeEntry[]> {
  const dealId = (scope.dealId || '').trim();
  const leadId = (scope.leadId || '').trim();
  if (!dealId) return [];

  const byId = new Map<string, LeadTimeEntry>();
  const lists = await Promise.all([
    leadId ? getLeadTimeEntries(leadId) : Promise.resolve([]),
    getLeadTimeEntriesByDeal(dealId),
  ]);
  for (const entry of lists.flat()) {
    if (!entry.id) continue;
    byId.set(entry.id, entry);
  }
  return selectLeadTimeForProject(Array.from(byId.values()), { dealId, leadId });
}
